import React from 'react';
import PropTypes from 'prop-types';

const TaskCompactList = ({ tasks = [] }) => {
  if (!tasks.length) {
    return (
      <div className="rounded-xl border border-indigo-100 bg-white px-4 py-3 text-sm text-slate-500">
        Aucune tâche à afficher.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {tasks.map((task) => (
        <div
          key={task.id}
          className="rounded-2xl border border-indigo-100/60 bg-white/90 p-4 shadow-sm"
        >
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
              <p className="text-sm font-semibold text-slate-900">{task.name}</p>
              <p className="text-xs text-slate-500">{task.objective_name || 'Objectif non précisé'}</p>
            </div>
            <span
              className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
                task.is_completed ? 'bg-emerald-100 text-emerald-700' : 'bg-indigo-100 text-indigo-700'
              }`}
            >
              {task.is_completed ? 'terminée' : 'en cours'}
            </span>
          </div>
          <div className="mt-3 flex flex-wrap gap-4 text-xs text-slate-600">
            <div>
              <span className="block text-[11px] uppercase tracking-wide text-slate-400">Owner</span>
              {task.owner_name || 'Non assignée'}
            </div>
            <div>
              <span className="block text-[11px] uppercase tracking-wide text-slate-400">Priorité</span>
              {task.priority || '—'}
            </div>
            <div>
              <span className="block text-[11px] uppercase tracking-wide text-slate-400">Échéance</span>
              {task.due_date ? new Date(task.due_date).toLocaleDateString() : '—'}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

TaskCompactList.propTypes = {
  tasks: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      name: PropTypes.string.isRequired,
      is_completed: PropTypes.bool,
      objective_name: PropTypes.string,
      owner_name: PropTypes.string,
      due_date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
      priority: PropTypes.string,
    })
  ),
};

export default TaskCompactList;
